<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'fridgestorages'">
  <div class="card">
    <p-breadcrumb
      class="breadcrumb-style max-w-full"
      [model]="breadcrumbMenuItems"
      [home]="breadcrumbHome"></p-breadcrumb>

    <div class="body-card py-3 px-4">
      <div class="header-card pt-0 mb-4 flex flex-row justify-content-between">
        <div class="w-12 container-title flex flex-column">
          <h1 class="text-xl font-medium text-800 m-0">
            {{ 'UserPages.UserFridgestorages.PageTitle' | translate }}
          </h1>
          <span class="text-800">{{'UserPages.UserFridgestorages.PageDescriptionText' | translate}}</span>
        </div>
        <div class="flex align-items-center justify-content-end">
          <p-button
            label="{{'UserPages.UserFridgestorages.NewButtonLabel' | translate}}"
            icon="pi pi-plus"
            class="mr-2 custom-text-button"
            (onClick)="goToCreateForm()"/>
        </div>
      </div>

      <p-table
        [loading]="loading"
        [value]="fridgestorages"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        responsiveLayout="stack"
        [breakpoint]="'600px'"
        class="custom-table">
        <ng-template pTemplate="header">
            <tr>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.StorageTypeHeader' | translate}}</div></th>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.NameHeader' | translate}}</div></th>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.ContactHeader' | translate}}</div></th>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.EmailHeader' | translate}}</div></th>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.CityHeader' | translate}}</div></th>
              <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.CountryHeader' | translate}}</div></th>
              <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fridgeStorage>
            <tr [pSelectableRow]="fridgeStorage">
              <td><div class="flex justify-content-center align-items-center">{{getStorageType(fridgeStorage.storageType)}}</div></td>
              <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.name}}</div></td>
              <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.contactName}}</div></td>
              <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.contactEmail}}</div></td>
              <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.contactCity}}</div></td>
              <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.contactCountry ? (fridgeStorage.contactCountry | countryDescription) : ''}}</div></td>
              <td>
                <div class="flex justify-content-end align-items-center gap-2">
                  <p-button
                    pTooltip="{{'UserPages.UserFridgestorages.FridgestorageTable.EditButton' | translate}}"
                    tooltipPosition="bottom"
                    icon="pi pi-pencil"
                    (onClick)="goToEditForm(fridgeStorage.id)"
                    class="custom-button-icon blue-btn mr-2"/>

                  <p-button
                    pTooltip="{{'UserPages.UserFridgestorages.FridgestorageTable.DeleteButton' | translate}}"
                    tooltipPosition="bottom"
                    icon="pi pi-trash"
                    (onClick)="onDelete(fridgeStorage.id)"
                    class="custom-button-icon red-btn"/>
                </div>
              </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</app-user-dashboard>


<p-confirmDialog acceptLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.YesLabel' | translate}}" rejectLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.NotLabel' | translate}}" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>
